import { Box, Skeleton, Stack } from "@mui/material";

const COLUMN_WIDTHS = ["28%", "22%", "18%", "16%", "16%"];

export const CertificatesSkeleton: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 1440, margin: "0 auto" }}>
      <Box
        sx={{
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        {/* Search */}
          <Box p={2}>
            <Skeleton
            variant="rounded"
            animation="wave"
            width={"100%"}
            height={40}
            sx={{ borderRadius: "12px" }}
          />
          </Box>

        {/* Table header */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            px: 2,
            py: 1.5,
            borderTop: (theme) => `1px solid ${theme.palette.divider}`,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            alignItems: "center",
          }}
        >
          <Skeleton
            variant="rounded"
            animation="wave"
            width={20}
            height={20}
          />
          {COLUMN_WIDTHS.map((width, i) => (
            <Skeleton
              key={i}
              variant="text"
              animation="wave"
              sx={{ fontSize: "14px", width }}
            />
          ))}
        </Stack>

        {/* Table rows */}
        {Array.from({ length: 6 }).map((_, rowIdx) => (
          <Stack
            key={rowIdx}
            direction="row"
            spacing={2}
            sx={{
              px: 2,
              py: 2,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              alignItems: "center",
            }}
          >
            <Skeleton
              variant="rounded"
              animation="wave"
              width={20}
              height={20}
            />
            {COLUMN_WIDTHS.map((width, i) => (
              <Skeleton
                key={i}
                variant="text"
                animation="wave"
                sx={{ fontSize: "16px", width }}
              />
            ))}
          </Stack>
        ))}

        {/* Pagination footer */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ p: 2 }}
        >
          <Skeleton
            variant="text"
            animation="wave"
            sx={{ fontSize: "14px", width: 140 }}
          />
          <Stack direction="row" spacing={1}>
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton
                key={i}
                variant="rounded"
                animation="wave"
                width={32}
                height={32}
              />
            ))}
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};
